import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEllipsisV,
    faTable,
    faCaretUp,
    faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Chart as ChartJS } from 'chart.js/auto';
import { Bar } from 'react-chartjs-2';
import { apiOfficeDemandSupplyChart } from '../../services/apis/retail/apiOfficeDemandSupplyChart';

class OfficeDemandSupplyChart extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            tooltipClassname: null,
            tooltipArrow: faCaretUp,
            tooltipArrowDisplay: 'none',
            tooltipYLabel: null,
            tooltipxLabel: null,
            chartOtions: {},
            chartData: {
                labels: [],
                datasets: []
            }
        }
    }

    componentDidMount() {
        const superClass = this;
        const options = {
            responsive: true,
            scales: {
                x: {
                    grid: {
                        display: false
                    }
                },
                y:
                {
                    // ticks: {
                    //     display: false
                    // },
                    grid: {
                        display: true,
                        drawBorder: true
                    }
                }
            },
            plugins: {
                legend: {
                    display: false,
                    // position: 'top',
                },
                title: {
                    display: false,
                    // text: 'Chart.js Bar Chart',
                },
                tooltip: {
                    enabled: false,
                    y: "bottom",
                    backgroundColor: '#FFFFFF',
                    external: function (context) {
                        // console.log(context);
                        var className = 'colorGreen';
                        var arrowDir = faCaretUp;
                        var CurrDataIndex = context.tooltip.dataPoints[0].dataIndex;
                        var PrevDataIndex = (CurrDataIndex == 0) ? 0 : (CurrDataIndex - 1);
                        // console.log(PrevDataIndex, CurrDataIndex, context.tooltip.dataPoints[0].dataset.data[PrevDataIndex], context.tooltip.dataPoints[0].dataset.data[CurrDataIndex])
                        if (parseFloat(context.tooltip.dataPoints[0].dataset.data[CurrDataIndex]) < parseFloat(context.tooltip.dataPoints[0].dataset.data[PrevDataIndex])) {
                            className = 'colorRed';
                            arrowDir = faCaretDown;
                        }
                        // if ((context.tooltip.dataPoints[0].parsed.y && context.tooltip.dataPoints[0].parsed.y !== superClass.state.tooltipYLabel) || (context.tooltip.dataPoints[0].label && context.tooltip.dataPoints[0].label !== superClass.state.tooltipxLabel)) {
                        superClass.setState({
                            tooltipClassname: className,
                            tooltipArrow: arrowDir,
                            tooltipArrowDisplay: '',
                            tooltipYLabel: context.tooltip.dataPoints[0].parsed.y,
                            tooltipxLabel: context.tooltip.dataPoints[0].label
                        });
                        // }
                    },
                }
            }
        };

        apiOfficeDemandSupplyChart.get().then((res) => {
            // this.setState({ officeDemandSupply: res.data });
            const data = {
                labels: res.data.x,
                datasets: [
                    {
                        // label: 'bar1',
                        data: res.data.datapoints.y1,
                        backgroundColor: 'rgba(76, 143, 234, 1)',
                        borderWidth: 0,
                        barThickness: 10,
                    },
                    {
                        // label: 'bar2',
                        data: res.data.datapoints.y2,
                        backgroundColor: 'rgba(224,224,224, 1)',
                        borderWidth: 0,
                        barThickness: 10,
                    }
                ],
            };

            superClass.setState({
                chartOtions: options,
                chartData: data
            });
        });


    }

    render() {
        return (
            <div className="col-lg-6">
                <div className="widget widgetGraph">
                    <div className="row">
                        <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                            <p>Ofﬁce Demand & Supply</p>
                            <h4 className={this.state.tooltipClassname}>
                                <FontAwesomeIcon icon={this.state.tooltipArrow} style={{ display: this.state.tooltipArrowDisplay }} />
                                {this.state.tooltipYLabel} &nbsp;
                            </h4>
                            <p className="colorBlack pSmall">{this.state.tooltipxLabel}&nbsp;</p>
                        </div>
                        <div className="col-lg-3 text-end">
                            <Link to="/#">
                                <FontAwesomeIcon icon={faTable} />
                            </Link>
                            <Link to="/#" className="colorBlack">
                                <FontAwesomeIcon icon={faEllipsisV} />
                            </Link>
                        </div>
                        <div className="col-lg-12"><Bar options={this.state.chartOtions} data={this.state.chartData} /></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OfficeDemandSupplyChart;